"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelConverter = void 0;
const plattar_api_1 = require("@plattar/plattar-api");
const object_hash_1 = __importDefault(require("object-hash"));
const remote_request_1 = require("./remote-request");
class ModelConverter {
    constructor() {
        this._model = null;
        this.quality = 100;
        this.output = "glb";
        this.server = "production";
        this.retry = 0;
        this._attrHash = [];
    }
    get model() {
        return this._model;
    }
    set model(newModel) {
        if (!newModel) {
            return;
        }
        if (newModel instanceof plattar_api_1.FileModel) {
            this._model = newModel.id;
            this._attrHash.push(object_hash_1.default.MD5(newModel.attributes));
            return;
        }
        this._model = newModel;
    }
    get() {
        return new Promise((accept, reject) => {
            if (!this._model) {
                return reject(new Error("ModelConverter.get() - required .model attribute was not set"));
            }
            remote_request_1.RemoteRequest.request(this._Payload, (this.retry < 0 ? 0 : this.retry)).then(accept).catch(reject);
        });
    }
    get _Payload() {
        const load = {
            options: {
                converter: "gltf_to_model",
                quality: this.quality,
                output: this.output,
                server: this.server
            },
            data: {
                model: this._model
            }
        };
        if (this._attrHash.length > 0) {
            load.options.hash = object_hash_1.default.MD5(this._attrHash) + object_hash_1.default.MD5(load);
        }
        else {
            load.options.hash = object_hash_1.default.MD5(load);
        }
        return load;
    }
}
exports.ModelConverter = ModelConverter;
